/**
 * The two places this app steps outside the design-system tokens, both for code: the monospace face
 * (the theme only carries Inter) and the syntax colours of the dark JSON surfaces, which have no
 * semantic role in the palette. Everything else styles through `@mg/ui`'s theme.
 */
export const MONO =
  "'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace";

export const CODE_COLORS = {
  bg: '#051C2C',
  tooltipBg: '#0B2A44',
  line: 'rgba(255, 255, 255, 0.06)',
  accent: '#0069E3',
  key: '#8FC1FF',
  string: '#0FD79B',
  number: '#FFB37A',
  literal: '#FF9A5C',
  punct: '#AAB2B7',
  error: '#FF9AB1',
  gutter: '#50606B',
  text: '#E5EAF6',
} as const;

/**
 * The same surface for Monaco, which only takes hex (with an alpha byte where translucency is
 * meant): white at low alpha over the navy background, pre-blended.
 */
export const MONACO_COLORS = {
  cursor: '#FFFFFF',
  gutterBackground: '#0B2234',
  lineHighlight: '#0A2439',
  selection: '#0069E373',
  inactiveSelection: '#0069E340',
  bracketMatch: '#0069E38C',
  widgetBorder: '#1C3B57',
  indentGuide: '#FFFFFF14',
  indentGuideActive: '#FFFFFF33',
  scrollbar: '#FFFFFF1F',
  transparent: '#00000000',
} as const;
